import React from 'react';
import { Table, Button } from 'reactstrap';
import { ReactComponent as DeleteIcon } from '../../../../assets/utils/images/svgs/Delete.svg';
import { ReactComponent as EditIcon } from '../../../../assets/utils/images/svgs/editPen.svg';
import { AFAS_DAGDELEN_COLUMNS } from '../constants';

const AfasDagdelenTable = ({ rows = [], onDelete, onEdit }) => {
    return (
        <div className="afas-dagdelen table-responsive">
            <div className="afas-dagdelen__table-wrap">
                <Table hover size="sm" className="mb-0 coor-verzoeken-table align-middle">
                    <thead 
                    >
                        <tr>
                            {AFAS_DAGDELEN_COLUMNS.map((column) => (
                                <th
                                    key={column.key}
                                    className={
                                        column.key === 'datum'
                                            ? 'text-start table-right-border'
                                            : undefined
                                    }
                                    style={column.key === 'datum' ? { width: '100px' } : undefined}
                                >
                                    {column.label}
                                </th>
                            ))}
                            <th aria-label="Acties" className="text-center" style={{ width: '60px' }}>
                                Acties
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        {rows.length === 0 ? (
                            <tr>
                                <td colSpan={AFAS_DAGDELEN_COLUMNS.length + 1} className="text-center text-muted py-3">
                                    Geen dagdelen
                                </td>
                            </tr>
                        ) : (
                            rows.map((row) => (
                                <tr key={row.dateKey || row.id}>
                                    {AFAS_DAGDELEN_COLUMNS.map((column) => (
                                        <td
                                            key={column.key}
                                            className={
                                                column.key === 'datum'
                                                    ? 'table-right-border'
                                                    : undefined
                                            }
                                            style={
                                                column.key === 'datum'
                                                    ? { width: '100px' }
                                                    : undefined
                                            }
                                        >
                                            {column.key === 'wtfPerDag'
                                                ? row.wtfPerDag || row.wtf || ''
                                                : row[column.key]}
                                        </td>
                                    ))}
                                    <td className="text-center">
                                        <div className="d-flex align-items-center justify-content-center gap-1">
                                            <Button
                                                type="button"
                                                color="link"
                                                size="sm"
                                                className="btn-icon p-0 text-primary"
                                                aria-label="Bewerken"
                                                onClick={() => onEdit?.(row)}
                                            >
                                                <EditIcon width={14} height={14} />
                                            </Button>
                                            <Button
                                                type="button"
                                                color="link"
                                                size="sm"
                                                className="btn-icon p-0 text-danger"
                                                aria-label="Verwijderen"
                                                onClick={() => onDelete?.(row)}
                                            >
                                                <DeleteIcon width={14} height={14} />
                                            </Button>
                                        </div>
                                    </td>
                                </tr>
                            ))
                        )}
                    </tbody>
                </Table>
            </div>
        </div>
    );
};

export default AfasDagdelenTable;
